module.exports = __webpack_public_path__ + "img/cross.681cfe49.svg";